import InfoSectionMobile from '~/modules/detail/components/info-section/InfoSectionMobile';

interface AwardSingleProps {
    title: string;
}

export const AwardRowSingleMobile: React.FC<AwardSingleProps> = ({ title }) => {
    return (
        <InfoSectionMobile label="">
            <b>{title}</b>
        </InfoSectionMobile>
    );
};
